var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{on:{"click":_vm.open}},[_c('IconEdit')],1),_c('form-modal',{attrs:{"type":"recordLabelEdit","title":"Edit Record Label","model":_vm.recordLabel,"isModal":_vm.isModal,"canDelete":_vm.$can.includes('delete-record-labels')},on:{"clear-modal":_vm.clearModal,"save-record":_vm.save,"delete-record":_vm.destroy}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }